export default __webpack_public_path__ + "static/media/check.cc73ba50.svg";